import { render } from "./JobConfigValidation.vue?vue&type=template&id=354dd552&scoped=true"
import script from "./JobConfigValidation.vue?vue&type=script&lang=js"
export * from "./JobConfigValidation.vue?vue&type=script&lang=js"

import "./JobConfigValidation.vue?vue&type=style&index=0&id=354dd552&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354dd552"]])

export default __exports__